export const PIVOT_CHECKEDIN = "1";
export const PIVOT_CHECKEDOUT = "2";
export const PIVOT_RECENT = "3";
export const PIVOT_SEARCH = "4";

export const STAY_NONE = "";
export const STAY_CHECKEDIN = "in";
export const STAY_CHECKEDOUT = "out";
